import React from "react";
import { useTranslation } from "react-i18next";

import { legendItemStyle, legendStyle } from "./style";

export const inlandFloodIspraLegendPerLevel = (t, zone) => {
  return (
    `Level : ` +
    [`${t("levels.noHazard")}`, `${t("levels.low")} `, `${t("levels.medium")} `, `${t("levels.high")} `][zone]
  );
};

export const InlandFloodIspraRiskLegend = ({ customLegendStyle = legendStyle }) => {
  const { t } = useTranslation();

  return (
    <div style={customLegendStyle}>
      <div>
        <b>{t("riskAssessment.inlandFloodIspra")} (ITA)</b>
      </div>
      <div>
        <span style={legendItemStyle("#F7F7F7")}></span>

        {inlandFloodIspraLegendPerLevel(t, 0)}
      </div>
      <div>
        <span style={legendItemStyle("#CAE9FA")}></span>
        {inlandFloodIspraLegendPerLevel(t, 1)}
      </div>
      <div>
        <span style={legendItemStyle("#106FFE")}></span>
        {inlandFloodIspraLegendPerLevel(t, 2)}
      </div>
      <div>
        <span style={legendItemStyle("#042575")}></span>
        {inlandFloodIspraLegendPerLevel(t, 3)}
      </div>
      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          © CyStellar, Data from IdroGEO ISPRA (v. 4.0 – 2020-2021) processed by CyStellar
        </span>
      </div>
    </div>
  );
};
